import classnames from 'classnames';
import { FunctionComponent } from 'react';

type LaptopAndPhoneProps = {
    className?: string;
};

const LaptopAndPhone: FunctionComponent<LaptopAndPhoneProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'laptop-and-phone'}
            viewBox="0 0 250 250"
        >
            <path
                fill="#FFFFFF"
                d="M243.1 187.8h-43.3c-1.1 0-2-.9-2-2V95.9c0-1.1.9-2 2-2h43.3c1.1 0 2 .9 2 2v89.9c0 1.1-.9 2-2 2z"
            />
            <path
                fill="#FFFFFF"
                d="M159.6 160.7H20c-1.1 0-2-.9-2-2V63.6c0-1.1.9-2 2-2h139.6c1.1 0 2 .9 2 2v95.1c0 1.1-.9 2-2 2z"
            />
            <path d="M159.6 165.2H20c-3.6 0-6.5-2.9-6.5-6.5V63.6c0-3.6 2.9-6.5 6.5-6.5h139.6c3.6 0 6.5 2.9 6.5 6.5v95.1c0 3.6-3 6.5-6.5 6.5zm-137.1-9h134.6V66.1H22.5v90.1z" />
            <path
                fill="#FFFFFF"
                d="M165.3 187.2H14.2c-.7 0-1.3-.4-1.3-.8l-8.1-24.8c0-.5.6-.8 1.3-.8h167.3c.7 0 1.3.4 1.3.8l-8.1 24.8c0 .4-.6.8-1.3.8z"
            />
            <path d="M173.4 156.2H6.1c-3.2 0-5.8 2.3-5.8 5.3v.7l8.2 25.1c.5 2.5 2.8 4.3 5.7 4.3h151.1c2.8 0 5.2-1.8 5.7-4.3l8.2-25.1v-.7c0-2.9-2.6-5.3-5.8-5.3zM163 182.7H16.5l-5.7-17.5h54.6l2.2 6.1c0 .1.2.2.3.2h41c.2 0 .3-.1.3-.2l2.2-6.1h57.3l-5.7 17.5z" />
            <path d="M243.1 89.4h-43.3c-3.6 0-6.5 2.9-6.5 6.5v89.9c0 3.6 2.9 6.5 6.5 6.5h43.3c3.6 0 6.5-2.9 6.5-6.5V95.9c0-3.6-2.9-6.5-6.5-6.5zm-2.5 93.9h-38.3V98.4h8.6l1 5.7c0 .1.1.2.2.2h18.7c.1 0 .2-.1.2-.2l1-5.7h8.8v84.9h-.2z" />
        </svg>
    );
};
export default LaptopAndPhone;
